import { type OldProductDTO, type OrderItemDTO, type ProductLightDTO } from 'ecosystem'
import lodashKeyBy from 'lodash/keyBy'
import { getProductWeight } from './products'

type PartialOrderItem = Pick<OrderItemDTO, 'quantity'> & { product: Pick<ProductLightDTO, 'id'> }
type ExtendedOrderItem<OrderItem> = OrderItem & { weight: number }

export const calculateOrderTotalWeight = <OrderItem extends PartialOrderItem>(
  orderItems: OrderItem[],
  fullProducts: OldProductDTO[]
): {
  totalWeight: number
  extendedItems: ExtendedOrderItem<OrderItem>[]
} => {
  const dictProducts = lodashKeyBy(fullProducts, 'id')

  return (
    orderItems?.reduce<{
      totalWeight: number
      extendedItems: ExtendedOrderItem<OrderItem>[]
    }>(
      (acc, item) => {
        const fullProduct = dictProducts[item.product.id]
        let productWeight = 0

        if (fullProduct) {
          productWeight = getProductWeight(fullProduct)
        }

        acc.extendedItems.push({
          ...item,
          weight: productWeight
        })
        acc.totalWeight += productWeight * item.quantity

        return acc
      },
      { totalWeight: 0, extendedItems: [] }
    ) ?? { totalWeight: 0, extendedItems: [] }
  )
}
